function doYotpoCustomCarousel() {
  if (customElements.get("yotpo-custom-carousel")) return null;

  class YotpoCustomCarousel extends HTMLElement {
    constructor() {
      super();

      this.yotpoCustomTabId = `yotpo-testimonials-custom-tab`;
      this.yotpoCustomTab = this.querySelector(`#${this.yotpoCustomTabId}`);
      this.starSvg = `<svg
      width="18"
      height="18"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="scale(1.2, 1.2)"
    >
      <defs><linearGradient id="yotpo_stars_gradient_0.5415841283598062"><stop offset="100%" stop-color="rgba(224,161,51,1)"></stop><stop offset="100%" stop-color="#FFFFFF" stop-opacity="1"></stop></linearGradient></defs><path d="M17.0919 25.4549L16.8335 25.299L16.5751 25.4549L7.39263 30.9971L9.82942 20.5516L9.89798 20.2577L9.66988 20.0601L1.55658 13.0315L12.2393 12.1252L12.5397 12.0997L12.6574 11.8221L16.8335 1.9688L21.0096 11.8221L21.1273 12.0997L21.4277 12.1252L32.1104 13.0315L23.9971 20.0601L23.769 20.2577L23.8376 20.5516L26.2744 30.9971L17.0919 25.4549Z" stroke="rgba(224,161,51,1)" fill="url(#yotpo_stars_gradient_0.5415841283598062)"></path>
    </svg>
    `;
      this.init();
    }

    init() {
      this.fetchReviews();
    }

    fetchReviews() {
      if (window.additionalAppData.yotpoApiKey == null) return null;
      const url = `https://api.yotpo.com/v1/widget/${window.additionalAppData.yotpoApiKey}/reviews.json?per_page=40`;

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          console.log(data);
          this.injectReviews(data.response);
        })
        .catch((error) => {
          console.error("There was a problem fetching the reviews:", error);
        });
    }

    initSlider() {
      const swiper = new Swiper(".ycc-slider", {
        direction: "horizontal",
        loop: false,
        autoHeight: true,
        slidesPerView: 1.2545,
        spaceBetween: 10,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        breakpoints: {
          1200: {
            spaceBetween: 14,
            slidesPerView: 2.345,
          },

          1415: {
            spaceBetween: 14,
            slidesPerView: 3.345,
          },

          1930: {
            spaceBetween: 14,
            slidesPerView: 4.345,
          },
        },
      });
    }

    sliderCardHtml(reviewData) {
      const {
        content,
        user: { display_name },
        title,
        score,
      } = reviewData;
      return `  <li class="swiper-slide"><article class="yccs-card">
      <div class="stars-container">
        <span>${this.starSvg}</span>
        <span>${this.starSvg}</span>
        <span>${this.starSvg}</span>
        <span>${this.starSvg}</span>
        <span>${this.starSvg}</span>
      </div>
      <h3>${title}</h3>
      <div class="yccs-body">
        <div class="yccs-content">${content}</div>
        <div class="yccs-footer">
          <p class="yccs-name">${display_name}</p>
        </div>
      </div>
    </article></li>`;
    }

    async injectReviews(responseData) {
      const { reviews } = responseData;
      if (reviews == null) return null;

      // const productIds = reviews
      //   .filter((review) => review.product_id)
      //   .map((review) => `gid://shopify/Product/${review.product_id}`);

      const sliderItems = reviews
        .map((review) => {
          return this.sliderCardHtml(review);
        })
        .join("");

      this.querySelector(".swiper-wrapper").innerHTML = sliderItems;
      this.initSlider();
    }

    /**
     * wip
     * @param {Array} productIds eg: ["gid://shopify/Product/8148334739755","gid://shopify/Product/8148334739755"]
     */
    async getShopifyProducts() {
      const productIds = ["gid://shopify/Product/477525548"];

      const productsInfo = fetch(`/api/2023-04/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "5bf90094285a1ed03f8e77e837f22ba4",
        },
        body: JSON.stringify({
          query: `
      query productsQuery($productIds: [ID!]!) {
        nodes(ids: $productIds) {
          ... on Product {
            id
            title
            handle
          }
        }
      }
    `,
          variables: {
            productIds: productIds,
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          // return data;
        })
        .catch((error) => {
          console.error(error);
          // return null;
        });

      return { productsInfo };
    }
  }

  customElements.define("yotpo-custom-carousel", YotpoCustomCarousel);
}
doYotpoCustomCarousel();
